var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnion2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 693,
    viewBox: "0 0 80 693",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V213V217V693C0.34632 683.5 10.9091 663 41.039 647C71.188 630.99 80 606.833 80 596.5V217V213V96.5C80 86.1667 71.188 62.0102 41.039 46C10.9091 30 0.34632 9.5 0 0Z",
    fill: "#171818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion2);
export default __webpack_public_path__ + "static/media/Union2.80917a1bd7e8e27e9a6c7f41051e54cb.svg";
export { ForwardRef as ReactComponent };